import { useT } from "../i18n";
import type { AutoCatalog } from "../types";
import { PeriodSel, durationText, fmtD, fmtDT, fmtT, resolve, secToIso, stepFor, stepText } from "../utils/period";

// The period block at the top of a telemetry panel: exact bounds, duration,
// the table step a PDF would use, the file it came from — plus the two actions.
export default function PeriodCard({ label, sel, catalog, onChange, onPdf }: {
  label: string; sel: PeriodSel; catalog: AutoCatalog | null; onChange: () => void; onPdf?: () => void;
}) {
  const { t } = useT();
  const r = resolve(sel, catalog?.data_from, catalog?.data_to);
  const fromIso = r ? secToIso(r.from) : null, toIso = r ? secToIso(r.to) : null;
  const sameDay = fromIso && toIso && fromIso.slice(0, 10) === toIso.slice(0, 10);
  const span = r ? r.to - r.from + 1 : 0;
  const line = !fromIso || !toIso ? "—"
    : sameDay ? `${fmtD(fromIso)} ${fmtT(fromIso)} → ${fmtT(toIso)}`
    : `${fmtDT(fromIso)} → ${fmtDT(toIso)}`;
  const parts = [
    sel.kind === "all" ? t("period.q_all") : null,
    r ? durationText(span, t) : null,
    r && onPdf ? stepText(stepFor(span), t) : null,   // the table step only matters for the PDF
    sel.kind === "file" && sel.file ? `${t("period.file")} «${sel.file.filename}»` : null,
    sel.kind === "preset" && sel.preset === "lastday" ? t("period.q_lastday") : null,
  ].filter(Boolean);
  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 12, color: "var(--hint)" }}>{t("period.title")} · {label}</div>
      <div style={{ fontSize: 16, fontWeight: 600, fontVariantNumeric: "tabular-nums", margin: "2px 0" }}>{line}</div>
      <div style={{ fontSize: 12, color: "var(--hint)" }}>{parts.join(" · ")}</div>
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button className="btn secondary" style={{ padding: "10px 12px" }} onClick={onChange}>{t("period.change")}</button>
        {onPdf && <button className="btn pdf" style={{ padding: "10px 12px", maxWidth: 120 }} onClick={onPdf} disabled={!r}>📄 PDF</button>}
      </div>
    </div>
  );
}
